import isFunction from 'lodash/isFunction';
import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import './glazingSelector.scss';

class GlazingSelectorController {
    constructor($sce, imagesService, dataService, sashesService) {
        if (angular.isUndefined(this.selectedSpacerId)) {
            this.selectedSpacerId = [];
        }

        if (angular.isUndefined(this.selectedGlazingId)) {
            this.selectedGlazingId = [];
        }

        this.sce = $sce;
        this.imagesService = imagesService;
        this.dataService = dataService;
        this.sashesService = sashesService;
        this.fieldName = null;
    }


    $onInit() {
        this.selectedSpacerId = this.dataService.getSelectedOptionId('glazingSpacers');
        this.selectedGlazingId = this.dataService.getSelectedOptionId('glazing');
        this.glazingOptions = this.getGlazingOptions();
        this.spacerOptions = this.getSpacerOptions();
        this.glazingChambers = this.glazingOptions.find(glazing => glazing.id == this.selectedGlazingId).attributes.chambers;
    }

    getGlazingOptions() {
        return this.dataService.getAttributeOptions('glazing');
    }

    getSpacerOptions() {
        return this.dataService.getAttributeOptions('glazingSpacers');
    }

    toggleSelectedGlazing(id) {
        this.selectedGlazingId = id;
        this.dataService.updateSelectedOptions('glazing', this.selectedGlazingId, 'glazing', false);
    }

    toggleSelectedSpacer(id) {
        this.selectedSpacerId = id;
        this.dataService.updateSelectedOptions('glazingSpacers', this.selectedSpacerId, 'glazingSpacers', true);
    }

    isSelectedGlazing(id) {
        return this.selectedGlazingId === id; // eslint-disable-line eqeqeq
    }

    isSelectedSpacer(id) {
        return this.selectedSpacerId === id; // eslint-disable-line eqeqeq
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback();
        }
        this.selectedOptions = [];
    }

    getGlazingImage(imgSrc) {
        return this.imagesService.getFullUrl(imgSrc);
    }

    getSpacerImage(imgSrc) {
        return '/files/glazingspacers/' + imgSrc;
    }
}

GlazingSelectorController.$inject = ['$sce', 'imagesService', 'dataService', 'sashesService'];

export default GlazingSelectorController;
